import createBreakpoint from 'src/design/styleguide/common/createBreakpoint';

export const breakpoint2xSmall = createBreakpoint('425px');
export const breakpointXSmall = createBreakpoint('576px');
export const breakpointSmall = createBreakpoint('768px');
export const breakpointMedium = createBreakpoint('992px');
export const breakpointLarge = createBreakpoint('1100px');
